import { AddressFormValues } from './address-form-values.interface';

export const initialAddressFormValues: AddressFormValues = {
  firstName: '',
  lastName: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  provinceState: '',
  country: '',
  zipPostalCode: '',
};